/** Briefdruck im gemeinsamen UI-Vokabular der Versandkanäle (Backend-Wert: „letter“). */
export const DELIVERY_CHANNEL_PRINT = "print";
